export default "__VITE_ASSET__4K64BSqL__"